import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  $serializer_getInstance3qhgvjcaya2da as $serializer_getInstance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from './supportModels.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function PaymentRequest$Companion$$childSerializers$_anonymous__jlkznl() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.v8s_1 = [null, null, lazy(tmp_0, PaymentRequest$Companion$$childSerializers$_anonymous__jlkznl)];
      }
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PaymentRequest', this, 3);
        tmp0_serialDesc.a1b('amount', false);
        tmp0_serialDesc.a1b('method', false);
        tmp0_serialDesc.a1b('idempotencyKey', false);
        this.t9k_1 = tmp0_serialDesc;
      }
      u9k(encoder, value) {
        var tmp0_desc = this.t9k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().v8s_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance(), new (MonetaryValue())(value.v9k_1));
        tmp1_output.a15(tmp0_desc, 1, value.w9k_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.x9k_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u9k(encoder, value instanceof PaymentRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t9k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance().v8s_1;
        if (tmp7_input.a14()) {
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp7_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp7_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return PaymentRequest().y9k(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.t9k_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance().v8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var PaymentRequestClass;
function PaymentRequest() {
  if (PaymentRequestClass === VOID) {
    class $ {
      constructor(amount, method, idempotencyKey) {
        Companion_getInstance();
        this.v9k_1 = amount;
        this.w9k_1 = method;
        this.x9k_1 = idempotencyKey;
      }
      toString() {
        return 'PaymentRequest(amount=' + MonetaryValue__toString_impl_xslc77(this.v9k_1) + ', method=' + this.w9k_1 + ', idempotencyKey=' + this.x9k_1.toString() + ')';
      }
      hashCode() {
        var result = MonetaryValue__hashCode_impl_fhcsz2(this.v9k_1);
        result = imul(result, 31) + getStringHashCode(this.w9k_1) | 0;
        result = imul(result, 31) + this.x9k_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PaymentRequest()))
          return false;
        if (!(this.v9k_1 === other.v9k_1))
          return false;
        if (!(this.w9k_1 === other.w9k_1))
          return false;
        if (!this.x9k_1.equals(other.x9k_1))
          return false;
        return true;
      }
      static y9k(seen0, amount, method, idempotencyKey, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_0().t9k_1);
        }
        var $this = createThis(this);
        $this.v9k_1 = amount;
        $this.w9k_1 = method;
        $this.x9k_1 = idempotencyKey;
        return $this;
      }
    }
    initMetadataForClass($, 'PaymentRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    PaymentRequestClass = $;
  }
  return PaymentRequestClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PaymentMethod', this, 4);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('name', false);
        tmp0_serialDesc.a1b('bank', false);
        tmp0_serialDesc.a1b('default', false);
        this.z9k_1 = tmp0_serialDesc;
      }
      a9l(encoder, value) {
        var tmp0_desc = this.z9k_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.h70_1);
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.i70_1);
        tmp1_output.d15(tmp0_desc, 2, $serializer_getInstance_2(), value.j70_1);
        tmp1_output.s14(tmp0_desc, 3, value.k70_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a9l(encoder, value instanceof PaymentMethod() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z9k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, $serializer_getInstance_2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, $serializer_getInstance_2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return PaymentMethod().b9l(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.z9k_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var PaymentMethodClass;
function PaymentMethod() {
  if (PaymentMethodClass === VOID) {
    class $ {
      constructor(id, name, bank, default_0) {
        this.h70_1 = id;
        this.i70_1 = name;
        this.j70_1 = bank;
        this.k70_1 = default_0;
      }
      c9l(id, name, bank, default_0) {
        return new (PaymentMethod())(id, name, bank, default_0);
      }
      m70(id, name, bank, default_0, $super) {
        id = id === VOID ? this.h70_1 : id;
        name = name === VOID ? this.i70_1 : name;
        bank = bank === VOID ? this.j70_1 : bank;
        default_0 = default_0 === VOID ? this.k70_1 : default_0;
        return $super === VOID ? this.c9l(id, name, bank, default_0) : $super.c9l.call(this, id, name, bank, default_0);
      }
      toString() {
        return 'PaymentMethod(id=' + this.h70_1 + ', name=' + this.i70_1 + ', bank=' + toString(this.j70_1) + ', default=' + this.k70_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h70_1);
        result = imul(result, 31) + (this.i70_1 == null ? 0 : getStringHashCode(this.i70_1)) | 0;
        result = imul(result, 31) + (this.j70_1 == null ? 0 : this.j70_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.k70_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PaymentMethod()))
          return false;
        if (!(this.h70_1 === other.h70_1))
          return false;
        if (!(this.i70_1 == other.i70_1))
          return false;
        if (!equals(this.j70_1, other.j70_1))
          return false;
        if (!(this.k70_1 === other.k70_1))
          return false;
        return true;
      }
      static b9l(seen0, id, name, bank, default_0, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_1().z9k_1);
        }
        var $this = createThis(this);
        $this.h70_1 = id;
        $this.i70_1 = name;
        $this.j70_1 = bank;
        $this.k70_1 = default_0;
        return $this;
      }
    }
    initMetadataForClass($, 'PaymentMethod', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    PaymentMethodClass = $;
  }
  return PaymentMethodClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.y8s_1.f2();
}
function PaymentTransferMethod$Companion$_anonymous__3e99fn() {
  return createSimpleEnumSerializer('com.crowpay.PaymentTransferMethod', values());
}
var PaymentTransferMethod_TwoThreeDay_instance;
var PaymentTransferMethod_SameDay_instance;
var PaymentTransferMethod_CrowPayCard_instance;
var PaymentTransferMethod_MailedCheck_instance;
var PaymentTransferMethod_WireTransfer_instance;
function values() {
  return [PaymentTransferMethod_TwoThreeDay_getInstance(), PaymentTransferMethod_SameDay_getInstance(), PaymentTransferMethod_CrowPayCard_getInstance(), PaymentTransferMethod_MailedCheck_getInstance(), PaymentTransferMethod_WireTransfer_getInstance()];
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.y8s_1 = lazy(tmp_0, PaymentTransferMethod$Companion$_anonymous__3e99fn);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  PaymentTransferMethod_initEntries();
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var PaymentTransferMethod_entriesInitialized;
function PaymentTransferMethod_initEntries() {
  if (PaymentTransferMethod_entriesInitialized)
    return Unit_instance;
  PaymentTransferMethod_entriesInitialized = true;
  PaymentTransferMethod_TwoThreeDay_instance = PaymentTransferMethod().g9l('TwoThreeDay', 0, '2-3 Day');
  PaymentTransferMethod_SameDay_instance = PaymentTransferMethod().g9l('SameDay', 1, 'Same Day');
  PaymentTransferMethod_CrowPayCard_instance = PaymentTransferMethod().g9l('CrowPayCard', 2, 'CrowPay Card');
  PaymentTransferMethod_MailedCheck_instance = PaymentTransferMethod().g9l('MailedCheck', 3, 'Mail Check');
  PaymentTransferMethod_WireTransfer_instance = PaymentTransferMethod().g9l('WireTransfer', 4, 'Wire Transfer');
  Companion_getInstance_1();
}
var PaymentTransferMethodClass;
function PaymentTransferMethod() {
  if (PaymentTransferMethodClass === VOID) {
    class $ extends Enum() {
      static g9l(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.f9l_1 = displayName;
        return $this;
      }
      e90() {
        return this.f9l_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'PaymentTransferMethod', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_1});
    PaymentTransferMethodClass = $;
  }
  return PaymentTransferMethodClass;
}
function Bank$Companion$$childSerializers$_anonymous__ium1v2() {
  return Companion_getInstance_4().k2a();
}
function Bank$Companion$$childSerializers$_anonymous__ium1v2_0() {
  return Companion_getInstance_3().k2a();
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Bank$Companion$$childSerializers$_anonymous__ium1v2);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u8s_1 = [tmp_1, lazy(tmp_2, Bank$Companion$$childSerializers$_anonymous__ium1v2_0), null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Bank', this, 6);
        tmp0_serialDesc.a1b('accountHolderType', false);
        tmp0_serialDesc.a1b('accountType', false);
        tmp0_serialDesc.a1b('accountId', false);
        tmp0_serialDesc.a1b('accountNumber', false);
        tmp0_serialDesc.a1b('routingNumber', false);
        tmp0_serialDesc.a1b('bankName', false);
        this.h9l_1 = tmp0_serialDesc;
      }
      i9l(encoder, value) {
        var tmp0_desc = this.h9l_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().u8s_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.j9l_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.k9l_1);
        tmp1_output.a15(tmp0_desc, 2, value.l9l_1);
        tmp1_output.a15(tmp0_desc, 3, value.m9l_1);
        tmp1_output.a15(tmp0_desc, 4, value.n9l_1);
        tmp1_output.a15(tmp0_desc, 5, value.o9l_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i9l(encoder, value instanceof Bank() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h9l_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance_2().u8s_1;
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, tmp11_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, tmp11_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return Bank().p9l(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      az() {
        return this.h9l_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_2().u8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_2() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var BankClass;
function Bank() {
  if (BankClass === VOID) {
    class $ {
      toString() {
        return 'Bank(accountHolderType=' + this.j9l_1.toString() + ', accountType=' + this.k9l_1.toString() + ', accountId=' + this.l9l_1 + ', accountNumber=' + this.m9l_1 + ', routingNumber=' + this.n9l_1 + ', bankName=' + this.o9l_1 + ')';
      }
      hashCode() {
        var result = this.j9l_1.hashCode();
        result = imul(result, 31) + this.k9l_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.l9l_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m9l_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n9l_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o9l_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Bank()))
          return false;
        if (!this.j9l_1.equals(other.j9l_1))
          return false;
        if (!this.k9l_1.equals(other.k9l_1))
          return false;
        if (!(this.l9l_1 === other.l9l_1))
          return false;
        if (!(this.m9l_1 === other.m9l_1))
          return false;
        if (!(this.n9l_1 === other.n9l_1))
          return false;
        if (!(this.o9l_1 === other.o9l_1))
          return false;
        return true;
      }
      static p9l(seen0, accountHolderType, accountType, accountId, accountNumber, routingNumber, bankName, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(63 === (63 & seen0))) {
          throwMissingFieldException(seen0, 63, $serializer_getInstance_2().h9l_1);
        }
        var $this = createThis(this);
        $this.j9l_1 = accountHolderType;
        $this.k9l_1 = accountType;
        $this.l9l_1 = accountId;
        $this.m9l_1 = accountNumber;
        $this.n9l_1 = routingNumber;
        $this.o9l_1 = bankName;
        return $this;
      }
    }
    initMetadataForClass($, 'Bank', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    BankClass = $;
  }
  return BankClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.s8s_1.f2();
}
function BankAccountType$Companion$_anonymous__qtedb8() {
  return createSimpleEnumSerializer('com.crowpay.BankAccountType', values_0());
}
var BankAccountType_checking_instance;
var BankAccountType_savings_instance;
function values_0() {
  return [BankAccountType_checking_getInstance(), BankAccountType_savings_getInstance()];
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.s8s_1 = lazy(tmp_0, BankAccountType$Companion$_anonymous__qtedb8);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  BankAccountType_initEntries();
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var BankAccountType_entriesInitialized;
function BankAccountType_initEntries() {
  if (BankAccountType_entriesInitialized)
    return Unit_instance;
  BankAccountType_entriesInitialized = true;
  BankAccountType_checking_instance = BankAccountType().s9l('checking', 0);
  BankAccountType_savings_instance = BankAccountType().s9l('savings', 1);
  Companion_getInstance_3();
}
var BankAccountTypeClass;
function BankAccountType() {
  if (BankAccountTypeClass === VOID) {
    class $ extends Enum() {
      static s9l(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'BankAccountType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    BankAccountTypeClass = $;
  }
  return BankAccountTypeClass;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.t8s_1.f2();
}
function BankAccountHolderType$Companion$_anonymous__y4easo() {
  return createSimpleEnumSerializer('com.crowpay.BankAccountHolderType', values_1());
}
var BankAccountHolderType_company_instance;
var BankAccountHolderType_individual_instance;
function values_1() {
  return [BankAccountHolderType_company_getInstance(), BankAccountHolderType_individual_getInstance()];
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.t8s_1 = lazy(tmp_0, BankAccountHolderType$Companion$_anonymous__y4easo);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  BankAccountHolderType_initEntries();
  if (Companion_instance_4 === VOID)
    new (Companion_4())();
  return Companion_instance_4;
}
var BankAccountHolderType_entriesInitialized;
function BankAccountHolderType_initEntries() {
  if (BankAccountHolderType_entriesInitialized)
    return Unit_instance;
  BankAccountHolderType_entriesInitialized = true;
  BankAccountHolderType_company_instance = BankAccountHolderType().v9l('company', 0);
  BankAccountHolderType_individual_instance = BankAccountHolderType().v9l('individual', 1);
  Companion_getInstance_4();
}
var BankAccountHolderTypeClass;
function BankAccountHolderType() {
  if (BankAccountHolderTypeClass === VOID) {
    class $ extends Enum() {
      static v9l(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'BankAccountHolderType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    BankAccountHolderTypeClass = $;
  }
  return BankAccountHolderTypeClass;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.MicroDepositVerification', this, 3);
        tmp0_serialDesc.a1b('arrivalDate', false);
        tmp0_serialDesc.a1b('verificationUrl', false);
        tmp0_serialDesc.a1b('type', false);
        this.w9l_1 = tmp0_serialDesc;
      }
      x9l(encoder, value) {
        var tmp0_desc = this.w9l_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), value.y9l_1);
        tmp1_output.a15(tmp0_desc, 1, value.z9l_1);
        tmp1_output.a15(tmp0_desc, 2, value.a9m_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x9l(encoder, value instanceof MicroDepositVerification() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w9l_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return MicroDepositVerification().b9m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.w9l_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [InstantIso8601Serializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_3() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var MicroDepositVerificationClass;
function MicroDepositVerification() {
  if (MicroDepositVerificationClass === VOID) {
    class $ {
      toString() {
        return 'MicroDepositVerification(arrivalDate=' + this.y9l_1.toString() + ', verificationUrl=' + this.z9l_1 + ', type=' + this.a9m_1 + ')';
      }
      hashCode() {
        var result = this.y9l_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.z9l_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a9m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MicroDepositVerification()))
          return false;
        if (!this.y9l_1.equals(other.y9l_1))
          return false;
        if (!(this.z9l_1 === other.z9l_1))
          return false;
        if (!(this.a9m_1 === other.a9m_1))
          return false;
        return true;
      }
      static b9m(seen0, arrivalDate, verificationUrl, type, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_3().w9l_1);
        }
        var $this = createThis(this);
        $this.y9l_1 = arrivalDate;
        $this.z9l_1 = verificationUrl;
        $this.a9m_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'MicroDepositVerification', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    MicroDepositVerificationClass = $;
  }
  return MicroDepositVerificationClass;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PendingAction', this, 2);
        tmp0_serialDesc.a1b('type', false);
        tmp0_serialDesc.a1b('verifyWithMicroDeposits', false);
        this.c9m_1 = tmp0_serialDesc;
      }
      d9m(encoder, value) {
        var tmp0_desc = this.c9m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.e9m_1);
        tmp1_output.d15(tmp0_desc, 1, $serializer_getInstance_3(), value.f9m_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d9m(encoder, value instanceof PendingAction() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c9m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PendingAction().g9m(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.c9m_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_3())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_4() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var PendingActionClass;
function PendingAction() {
  if (PendingActionClass === VOID) {
    class $ {
      toString() {
        return 'PendingAction(type=' + this.e9m_1 + ', verifyWithMicroDeposits=' + toString(this.f9m_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.e9m_1);
        result = imul(result, 31) + (this.f9m_1 == null ? 0 : this.f9m_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PendingAction()))
          return false;
        if (!(this.e9m_1 === other.e9m_1))
          return false;
        if (!equals(this.f9m_1, other.f9m_1))
          return false;
        return true;
      }
      static g9m(seen0, type, verifyWithMicroDeposits, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_4().c9m_1);
        }
        var $this = createThis(this);
        $this.e9m_1 = type;
        $this.f9m_1 = verifyWithMicroDeposits;
        return $this;
      }
    }
    initMetadataForClass($, 'PendingAction', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    PendingActionClass = $;
  }
  return PendingActionClass;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.PendingPaymentMethod', this, 3);
        tmp0_serialDesc.a1b('secret', false);
        tmp0_serialDesc.a1b('method', false);
        tmp0_serialDesc.a1b('action', false);
        this.h9m_1 = tmp0_serialDesc;
      }
      i9m(encoder, value) {
        var tmp0_desc = this.h9m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.j9m_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_1(), value.k9m_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_4(), value.l9m_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i9m(encoder, value instanceof PendingPaymentMethod() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h9m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, $serializer_getInstance_4(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return PendingPaymentMethod().m9m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.h9m_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), $serializer_getInstance_1(), $serializer_getInstance_4()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_5() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var PendingPaymentMethodClass;
function PendingPaymentMethod() {
  if (PendingPaymentMethodClass === VOID) {
    class $ {
      toString() {
        return 'PendingPaymentMethod(secret=' + this.j9m_1 + ', method=' + this.k9m_1.toString() + ', action=' + this.l9m_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j9m_1);
        result = imul(result, 31) + this.k9m_1.hashCode() | 0;
        result = imul(result, 31) + this.l9m_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PendingPaymentMethod()))
          return false;
        if (!(this.j9m_1 === other.j9m_1))
          return false;
        if (!this.k9m_1.equals(other.k9m_1))
          return false;
        if (!this.l9m_1.equals(other.l9m_1))
          return false;
        return true;
      }
      static m9m(seen0, secret, method, action, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_5().h9m_1);
        }
        var $this = createThis(this);
        $this.j9m_1 = secret;
        $this.k9m_1 = method;
        $this.l9m_1 = action;
        return $this;
      }
    }
    initMetadataForClass($, 'PendingPaymentMethod', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
    PendingPaymentMethodClass = $;
  }
  return PendingPaymentMethodClass;
}
function Payment$Companion$$childSerializers$_anonymous__58lajg() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function Payment$Companion$$childSerializers$_anonymous__58lajg_0() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Payment$Companion$$childSerializers$_anonymous__58lajg);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w8s_1 = [null, null, tmp_1, lazy(tmp_2, Payment$Companion$$childSerializers$_anonymous__58lajg_0)];
      }
      k2a() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new (Companion_8())();
  return Companion_instance_8;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.Payment', this, 4);
        tmp0_serialDesc.a1b('amount', false);
        tmp0_serialDesc.a1b('method', false);
        tmp0_serialDesc.a1b('idempotencyKey', false);
        tmp0_serialDesc.a1b('ledgerId', false);
        this.n9m_1 = tmp0_serialDesc;
      }
      o9m(encoder, value) {
        var tmp0_desc = this.n9m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_8().w8s_1;
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance(), new (MonetaryValue())(value.p9m_1));
        tmp1_output.a15(tmp0_desc, 1, value.q9m_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.r9m_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.s9m_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o9m(encoder, value instanceof Payment() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n9m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_8().w8s_1;
        if (tmp8_input.a14()) {
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp8_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.y5r_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp8_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.y5r_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return Payment().t9m(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.n9m_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_8().w8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), tmp0_cached[3].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_6() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var PaymentClass;
function Payment() {
  if (PaymentClass === VOID) {
    class $ {
      toString() {
        return 'Payment(amount=' + MonetaryValue__toString_impl_xslc77(this.p9m_1) + ', method=' + this.q9m_1 + ', idempotencyKey=' + this.r9m_1.toString() + ', ledgerId=' + this.s9m_1.toString() + ')';
      }
      hashCode() {
        var result = MonetaryValue__hashCode_impl_fhcsz2(this.p9m_1);
        result = imul(result, 31) + getStringHashCode(this.q9m_1) | 0;
        result = imul(result, 31) + this.r9m_1.hashCode() | 0;
        result = imul(result, 31) + this.s9m_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Payment()))
          return false;
        if (!(this.p9m_1 === other.p9m_1))
          return false;
        if (!(this.q9m_1 === other.q9m_1))
          return false;
        if (!this.r9m_1.equals(other.r9m_1))
          return false;
        if (!this.s9m_1.equals(other.s9m_1))
          return false;
        return true;
      }
      static t9m(seen0, amount, method, idempotencyKey, ledgerId, serializationConstructorMarker) {
        Companion_getInstance_8();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_6().n9m_1);
        }
        var $this = createThis(this);
        $this.p9m_1 = amount;
        $this.q9m_1 = method;
        $this.r9m_1 = idempotencyKey;
        $this.s9m_1 = ledgerId;
        return $this;
      }
    }
    initMetadataForClass($, 'Payment', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
    PaymentClass = $;
  }
  return PaymentClass;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.x8s_1.f2();
}
function PaymentStatus$Companion$_anonymous__lu18p() {
  return createSimpleEnumSerializer('com.crowpay.PaymentStatus', values_2());
}
var PaymentStatus_failed_instance;
var PaymentStatus_pending_instance;
var PaymentStatus_succeeded_instance;
function values_2() {
  return [PaymentStatus_failed_getInstance(), PaymentStatus_pending_getInstance(), PaymentStatus_succeeded_getInstance()];
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      constructor() {
        Companion_instance_9 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.x8s_1 = lazy(tmp_0, PaymentStatus$Companion$_anonymous__lu18p);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_2(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  PaymentStatus_initEntries();
  if (Companion_instance_9 === VOID)
    new (Companion_9())();
  return Companion_instance_9;
}
var PaymentStatus_entriesInitialized;
function PaymentStatus_initEntries() {
  if (PaymentStatus_entriesInitialized)
    return Unit_instance;
  PaymentStatus_entriesInitialized = true;
  PaymentStatus_failed_instance = PaymentStatus().w9m('failed', 0);
  PaymentStatus_pending_instance = PaymentStatus().w9m('pending', 1);
  PaymentStatus_succeeded_instance = PaymentStatus().w9m('succeeded', 2);
  Companion_getInstance_9();
}
var PaymentStatusClass;
function PaymentStatus() {
  if (PaymentStatusClass === VOID) {
    class $ extends Enum() {
      static w9m(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'PaymentStatus', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    PaymentStatusClass = $;
  }
  return PaymentStatusClass;
}
function PaymentTransferMethod_TwoThreeDay_getInstance() {
  PaymentTransferMethod_initEntries();
  return PaymentTransferMethod_TwoThreeDay_instance;
}
function PaymentTransferMethod_SameDay_getInstance() {
  PaymentTransferMethod_initEntries();
  return PaymentTransferMethod_SameDay_instance;
}
function PaymentTransferMethod_CrowPayCard_getInstance() {
  PaymentTransferMethod_initEntries();
  return PaymentTransferMethod_CrowPayCard_instance;
}
function PaymentTransferMethod_MailedCheck_getInstance() {
  PaymentTransferMethod_initEntries();
  return PaymentTransferMethod_MailedCheck_instance;
}
function PaymentTransferMethod_WireTransfer_getInstance() {
  PaymentTransferMethod_initEntries();
  return PaymentTransferMethod_WireTransfer_instance;
}
function BankAccountType_checking_getInstance() {
  BankAccountType_initEntries();
  return BankAccountType_checking_instance;
}
function BankAccountType_savings_getInstance() {
  BankAccountType_initEntries();
  return BankAccountType_savings_instance;
}
function BankAccountHolderType_company_getInstance() {
  BankAccountHolderType_initEntries();
  return BankAccountHolderType_company_instance;
}
function BankAccountHolderType_individual_getInstance() {
  BankAccountHolderType_initEntries();
  return BankAccountHolderType_individual_instance;
}
function PaymentStatus_failed_getInstance() {
  PaymentStatus_initEntries();
  return PaymentStatus_failed_instance;
}
function PaymentStatus_pending_getInstance() {
  PaymentStatus_initEntries();
  return PaymentStatus_pending_instance;
}
function PaymentStatus_succeeded_getInstance() {
  PaymentStatus_initEntries();
  return PaymentStatus_succeeded_instance;
}
//region block: init
Companion_instance_0 = new (Companion_0())();
Companion_instance_5 = new (Companion_5())();
Companion_instance_6 = new (Companion_6())();
Companion_instance_7 = new (Companion_7())();
//endregion
//region block: exports
export {
  Bank as Bank3v98rc3cm50hg,
  PaymentMethod as PaymentMethod1x8gg38hdlghq,
  PaymentRequest as PaymentRequest2wgfbtpc9jnmf,
  PaymentTransferMethod as PaymentTransferMethod2houca3ect5kw,
  PaymentTransferMethod_MailedCheck_getInstance as PaymentTransferMethod_MailedCheck_getInstance2hk9qsxywpjin,
  PaymentTransferMethod_SameDay_getInstance as PaymentTransferMethod_SameDay_getInstance1esd8e6oetmaq,
  PaymentTransferMethod_TwoThreeDay_getInstance as PaymentTransferMethod_TwoThreeDay_getInstanceq532502amdnm,
  Companion_getInstance_2 as Companion_getInstance32uepvayd1rp6,
  Companion_getInstance_4 as Companion_getInstance2dluix7bymsgj,
  Companion_getInstance_3 as Companion_getInstance2apjme156k7ik,
  Companion_instance_5 as Companion_instance1cl4ylbs1tj5h,
  Companion_getInstance_8 as Companion_getInstancehvtw6329m862,
  Companion_instance_0 as Companion_instance9tm2i64vxmrs,
  Companion_getInstance as Companion_getInstancelcczxht3hulj,
  Companion_getInstance_9 as Companion_getInstance1puvd92z6jrz1,
  Companion_getInstance_1 as Companion_getInstance2n82k3fb4nex0,
  Companion_instance_6 as Companion_instance3r6ft9suoephw,
  Companion_instance_7 as Companion_instance232bst47rpkpx,
};
//endregion

//# sourceMappingURL=paymentModels.mjs.map
